import { IAppStore } from 'shared/common/state';
import { mlSearchSession } from 'shared/mlSearchSession';
import { IApplicationContext } from 'shared/types/applicationContext';
import { triggerHeaderCategoryChanged } from 'shared/utils/events';

import { modifyPageViewAnalyticsEvent } from '../../utils/modifyPageViewAnalyticsEvent';
import { CommercialFiltersEventsLog } from '../events';
import { subscribeToInteractiveTime } from '../subscribeToInteractiveTime';

/**
 * Legacy
 * @deprecated
 */
export function legacyInitBeforeHydration(context: IApplicationContext, store: IAppStore) {
  const state = store.getState();

  triggerHeaderCategoryChanged(state.filters.jsonQuery);
  mlSearchSession.init(state.results.jsonQuery);
  subscribeToInteractiveTime({ store });
  CommercialFiltersEventsLog.init(store);

  /**
   * Обновляем сессию поиска пользователя, когда пользователь попал на ранжированную выдачу И
   * выдача не была закэширована ml-сервисом.
   */
  if (state.mlRankingGuid && !state.isMlRankingResponseCached) {
    mlSearchSession.updateSession(state.results.jsonQuery);
  }

  const pageViewParams = {
    page: { extra: { mlSearchSessionGuid: mlSearchSession.getSessionGuid(state.results.jsonQuery) } },
  };

  /**
   * Добавляем параметр mlSearchSessionGuid в объект события pageview при первом ренедере страницы.
   * Данный хак требуется, поскольку признак mlSearchSessionGuid существует только на стороне браузера
   * (хранится в sessionStorage).
   */
  modifyPageViewAnalyticsEvent(context, { pageViewParams });
}
